import { useMediaQuery } from "@vueuse/core";

export function useBreakpoints() {
  const isSm = useMediaQuery("(min-width:576px)");
  const isMd = useMediaQuery("(min-width:768px)");
  const isLg = useMediaQuery("(min-width:992px)");
  const isXl = useMediaQuery("(min-width:1200px)");
  const isXxl = useMediaQuery("(min-width:1400px)");
  return { isSm, isMd, isLg, isXl, isXxl };
}
